// Messages/Messages.jsx
// Refactored messages page with extracted components

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';
import { useMessagesData } from './useMessagesData';
import ThreadsList from './ThreadsList';

// Message Icon SVG
const MessageIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

// Spinner Icon SVG
const SpinnerIcon = () => (
  <svg 
    width="48" 
    height="48" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    style={styles.spinnerAnimation}
  >
    <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
  </svg>
);

// Lock Icon SVG
const LockIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const Messages = () => {
  const navigate = useNavigate();
  const { threads, userInfos, loading, currentUser } = useMessagesData();

  // Update localStorage when user visits Messages page (don't mark all as read globally)
  useEffect(() => {
    if (!currentUser) return;

    // Update localStorage to track messages page visit
    localStorage.setItem(`lastMessagesVisit_${currentUser.uid}`, new Date().toISOString());
    
    // Note: We don't mark all threads as read here - that should only happen when 
    // user actually clicks and visits a specific thread in DirectPage
  }, [currentUser]);

  const handleThreadClick = (threadId) => {
    navigate(`/direct/${threadId}`);
  };

  if (loading) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          <div style={styles.header}>
            <div style={styles.iconWrapper}>
              <MessageIcon />
            </div>
            <h1 style={styles.title}>Messages</h1>
            <p style={styles.subtitle}>Chat with buyers and sellers</p>
          </div>
          <div style={styles.loadingContainer}>
            <SpinnerIcon />
            <p style={styles.loadingText}>Loading conversations...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          <div style={styles.header}>
            <div style={styles.iconWrapper}>
              <MessageIcon />
            </div>
            <h1 style={styles.title}>Messages</h1>
            <p style={styles.subtitle}>Chat with buyers and sellers</p>
          </div>
          <div style={styles.noUserContainer}>
            <div style={styles.noUserIcon}>
              <LockIcon />
            </div>
            <h2 style={styles.noUserTitle}>Please log in to view messages</h2>
            <p style={styles.noUserMessage}>
              You need to be logged in to access your conversations
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.iconWrapper}>
            <MessageIcon />
          </div>
          <h1 style={styles.title}>Messages</h1>
          <p style={styles.subtitle}>
            {threads.length} {threads.length === 1 ? 'conversation' : 'conversations'}
          </p>
        </div>
        
        <div style={styles.content}>
          <ThreadsList
            threads={threads}
            userInfos={userInfos}
            currentUserId={currentUser.uid}
            onThreadClick={handleThreadClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Messages;